export function safeMsg(err, fallback = "Something went wrong") {
  const msg =
    err?.response?.data?.message ||
    err?.response?.data?.error ||
    err?.message ||
    fallback;

  return typeof msg === "string" ? msg : fallback;
}

export function fmtDate(v) {
  if (!v) return "-";
  try {
    const d = new Date(v);
    if (Number.isNaN(d.getTime())) return String(v);
    return new Intl.DateTimeFormat(undefined, {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    }).format(d);
  } catch {
    return String(v);
  }
}

export function initials(name = "") {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  return (parts[0][0] + (parts[1]?.[0] || "")).toUpperCase();
}

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export function filenameFromContentDisposition(cd, fallback = "download") {
  const raw = cd || "";
  const m =
    /filename\*?=(?:UTF-8''|")?([^;"\n]+)"/i.exec(raw) ||
    /filename=([^;"\n]+)/i.exec(raw);

  if (!m?.[1]) return fallback;
  try {
    return decodeURIComponent(m[1].replace(/"/g, ""));
  } catch {
    return m[1].replace(/"/g, "");
  }
}
